// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Reason-cls1__ce713cc59e80967a9b1f{/*!*/}.Reason-cls2__c98d1bd8753f6a97b4ba{display:flex;align-items:center;grid-gap:8px;gap:8px;color:#535366}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Reason-cls1__ce713cc59e80967a9b1f",
	"cls2": "Reason-cls2__c98d1bd8753f6a97b4ba Reason-cls1__ce713cc59e80967a9b1f"
};
export default ___CSS_LOADER_EXPORT___;
